import { network } from 'services/network';

export const createOrUpdateCard = (params) => {
    return network.post('api/bo/createOrUpdateCard', params).then((response) => {
        return response.data;
    });
};
